'use client';
import { Dialog, DialogTrigger } from '@vs-shop/ui/dialog';
import { useState } from 'react';

import ProductFavouritesButton from './ProductFavouritesButton';
import ProductFavouritesModalInteractive from './ProductFavouritesModalInteractive';

import { isLoggedInAtom } from '../../../../effect/atom/auth/auth';
import { authModalAtom, AuthModalMode } from '@vs-shop/engine/atom/ui/authModal';
import { useAtomSet, useAtomValue } from '@effect/atom-react';

type Props = {
  variant: 'card' | 'detail';
  productCode: string;
  productName: string;
  isFavourite: boolean;
};

export default function ProductFavouritesModal({
  variant,
  productCode,
  productName,
  isFavourite,
}: Props) {
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const setAuthModal = useAtomSet(authModalAtom);

  const handleOpenChange = (open: boolean) => {
    if (!open) return;

    if (!isLoggedIn) {
      setAuthModal({ isOpen: true, mode: AuthModalMode.addProductToFavourites });
      return;
    }

    setHasBeenOpened(true);
  };

  if (hasBeenOpened) {
    return (
      <ProductFavouritesModalInteractive
        variant={variant}
        productCode={productCode}
        productName={productName}
        isFavouriteInitial={isFavourite}
      />
    );
  }

  return (
    <Dialog onOpenChange={handleOpenChange}>
      <DialogTrigger
        render={<ProductFavouritesButton variant={variant} isFavourite={isFavourite} />}
      />
    </Dialog>
  );
}
